import { render, staticRenderFns } from "./SettingCardList.vue?vue&type=template&id=45ba4a0a&scoped=true&"
import script from "./SettingCardList.vue?vue&type=script&lang=js&"
export * from "./SettingCardList.vue?vue&type=script&lang=js&"
import style0 from "./SettingCardList.vue?vue&type=style&index=0&id=45ba4a0a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ba4a0a",
  null
  
)

export default component.exports